<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'marcas') {
            next({ name: 'marca-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'marcas') {
            this.$router.push({ name: 'marca-list' });
        }
    },
};
</script>
